import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
import OrderWebAPIUtils from 'utils/OrderWebAPIUtils';

const ActionTypes = AdminConstants.ActionTypes;

export default {
  generateDeliveryOrder(jobId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GENERATE_DELIVERY_ORDER_REQUEST,
      jobId,
    });
  },

  generateCustomDeliveryOrder(orderId, payload) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GENERATE_CUSTOM_DELIVERY_ORDER_REQUEST,
      orderId,
      payload,
    });
  },

  emailCustomDeliveryOrder(orderId, documentId, addresses) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.EMAIL_CUSTOM_DELIVERY_ORDER_REQUEST,
      orderId,
      documentId,
      addresses,
    });
  },

  resetOrderShipments() {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.RESET_ORDER_SHIPMENTS,
    });
  },

  resetStagingShipments() {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.RESET_STAGING_SHIPMENTS,
    });
  },

  getOrderShipments(orderId, options) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FETCH_ORDER_SHIPMENTS_REQUEST,
      orderId,
      options,
    });
  },

  getOrderTemplates(params = {}) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FETCH_ORDER_TEMPLATES_REQUEST,
      params,
    });
  },

  getOrders(params) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FETCH_ORDERS_REQUEST,
      params,
    });
  },
  getOrder(orderId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FETCH_ORDER_REQUEST,
      orderId,
    });
  },
  getOrderAudits(orderId) {
    OrderWebAPIUtils.getOrderAuditEvents(orderId);
  },
  transitionOrder(order, step, meta = {}) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.TRANSITION_ORDER_REQUEST,
      order,
      step,
      meta,
    });
  },
  createOrder(order, documentIds) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_ORDER_REQUEST,
      order,
      documentIds,
    });
  },

  // The old staging shipments
  createOrderShipment(offer) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_ORDER_SHIPMENT_REQUEST,
      offer,
    });
  },

  // The new non-staging shipments
  createShipmentFromOrder(orderId, options) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_SHIPMENT_FROM_ORDER_REQUEST,
      orderId,
      options,
    });
  },

  createOrderAndTemplate(name, order, documentIds) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_ORDER_AND_TEMPLATE_REQUEST,
      name,
      order,
      documentIds,
    });
  },

  saveTemplateAndBookOrder(id, name, order, documentIds) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SAVE_TEMPLATE_AND_BOOK_ORDER_REQUEST,
      id,
      name,
      order,
      documentIds,
    });
  },

  cancelOrder(orderId, reason) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CANCEL_ORDER_REQUEST,
      orderId,
      reason,
    });
  },

  reopenOrder(orderId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.REOPEN_ORDER_REQUEST,
      orderId,
    });
  },

  updateOrder(orderId, updates) {
    if (
      updates.arrival_date ||
      updates.last_free_date ||
      updates.estimated_arrival_date ||
      updates.earliest_return_date ||
      updates.earliest_empty
    ) {
      return AdminAppDispatcher.handleViewAction({
        type: ActionTypes.UPDATE_ORDER_DATES,
        orderId,
        updates,
      });
    }

    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_ORDER_REQUEST,
      orderId,
      updates,
    });
  },
  uploadOrderDocument(order, docType, file, meta = {}) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPLOAD_ORDER_DOCUMENT_REQUEST,
      orderId: order._id,
      docType,
      file,
      meta,
    });
  },
  deleteOrderDocument(order, documentId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DELETE_ORDER_DOCUMENT_REQUEST,
      order,
      documentId,
    });
  },
  addEquipmentToOrder(orderId, equipmentId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ADD_ORDER_EQUIPMENT_REQUEST,
      orderId,
      equipmentId,
    });
  },
  removeEquipmentFromOrder(orderId, equipmentId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.REMOVE_ORDER_EQUIPMENT_REQUEST,
      orderId,
      equipmentId,
    });
  },

  generateOrderInvoice(
    orderId,
    invoiceDate,
    selectedCharges = {},
    sendEdi = true,
    sendEmail = true,
    useShipmentAddress = false
  ) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GENERATE_ORDER_INVOICE_REQUEST,
      orderId,
      invoiceDate,
      selectedCharges,
      sendEdi,
      sendEmail,
      useShipmentAddress
    });
  },

  generateOrderPayout(
    orderId,
    payoutDate,
    selectedCharges = {},
    autoApprove = true,
  ) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GENERATE_ORDER_PAYOUT_REQUEST,
      orderId,
      payoutDate,
      selectedCharges,
      autoApprove,
    });
  },

  downloadOrdersCsv(filters, limit, activeColumns) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DOWNLOAD_ORDERS_CSV,
      filters,
      limit,
      activeColumns,
    });
  },

  bulkAddAccessorials(orderId, shipments) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.BULK_ADD_ACCESSORIALS_REQUEST,
      orderId,
      shipments,
    });
  },

  getOrdersByQuery(query) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ORDERS_SEARCH_BY_QUERY_REQUEST,
      query,
    });
  },

  addComment(orderId, comment) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ADD_ORDER_COMMENT_REQUEST,
      orderId,
      comment,
    });
  },
};
